import { styled } from '@root/stitches.config';

export const AssetBlockWrapper = styled('div', {
  margin: '$64 0',
});